import DOMPurify from "isomorphic-dompurify"

const ALLOWED_TAGS = [
    "p", "br", "strong", "b", "em", "i", "u", "s",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "a", "span",
    "blockquote", "code", "pre",
]

const ALLOWED_ATTR = ["href", "target", "rel", "style"]

export const sanitizeRichText = (html: string): string =>
    DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOW_DATA_ATTR: false,
    })

const HTML_TAG_RE = /<[a-z][\s\S]*?>/i

export const isHtmlContent = (text: string): boolean => HTML_TAG_RE.test(text)
